import PropTypes from "prop-types";

const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  const num = parseFloat(value);
  return Number.isFinite(num)
    ? num.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : value;
};

const MONTH_SHORT = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

// Parsed manually (not via Date) to avoid UTC/local timezone day-shift issues.
const parseDateParts = (value) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || "");
  if (!match) return null;
  const [, year, month, day] = match;
  return { year: Number(year), month: Number(month), day: Number(day) };
};

const renderDate = (value) => {
  const parts = parseDateParts(value);
  if (!parts) return "—";

  const display = `${String(parts.day).padStart(2, "0")}-${MONTH_SHORT[parts.month - 1]}-${parts.year}`;
  const title = `${String(parts.day).padStart(2, "0")}-${String(parts.month).padStart(2, "0")}-${parts.year}`;

  return <span title={title}>{display}</span>;
};

const REVISION_LABELS = {
  INITIAL: "Initial salary",
  INCREMENT: "Salary increment",
  ADJUSTMENT: "Salary correction",
};

const SalaryHistoryModal = ({ loading, employee, salaries, close }) => {
  return (
    <div
      className="modal d-block"
      tabIndex="-1"
      style={{ background: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header bg-light">
            <h5 className="modal-title fw-semibold">
              Salary History
              {employee ? ` — ${employee.emp_code || ""} ${employee.employee_name || ""}` : ""}
            </h5>
            <button type="button" className="btn-close" onClick={close}></button>
          </div>

          <div className="modal-body">
            {loading ? (
              <p className="text-muted mb-0">Loading salary history...</p>
            ) : salaries.length === 0 ? (
              <p className="text-muted mb-0">No salary history found for this employee.</p>
            ) : (
              <div className="table-responsive">
                <table className="table table-sm table-bordered align-middle">
                  <thead className="table-dark">
                    <tr>
                      <th>Previous Gross</th>
                      <th>Increment</th>
                      <th>Revised Gross</th>
                      <th>Effective From</th>
                      <th>Effective To</th>
                      <th>Revision Type</th>
                      <th>Status</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {salaries.map((salary, index) => (
                      <tr
                        key={index}
                        className={salary.status_id === 1 ? "table-success" : ""}
                      >
                        <td>{formatCurrency(salary.gross)}</td>
                        <td>{formatCurrency(salary.increment)}</td>
                        <td>{formatCurrency(salary.total_gross)}</td>
                        <td>{renderDate(salary.effective_from)}</td>
                        <td>{renderDate(salary.effective_to)}</td>
                        <td>{REVISION_LABELS[salary.revision_type] || salary.revision_type}</td>
                        <td>
                          <span
                            className={`badge ${
                              salary.status_id === 1 ? "bg-success" : "bg-secondary"
                            }`}
                          >
                            {salary.status || (salary.status_id === 1 ? "ACTIVE" : "INACTIVE")}
                          </span>
                        </td>
                        <td>{salary.notes || "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <div className="modal-footer bg-light">
            <button type="button" className="btn btn-secondary" onClick={close}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

SalaryHistoryModal.propTypes = {
  loading: PropTypes.bool,
  employee: PropTypes.object,
  salaries: PropTypes.array.isRequired,
  close: PropTypes.func.isRequired,
};

export default SalaryHistoryModal;
